<div class="w-full h-full" fxLayout="row wrap">
    <mat-card class="mat-elevation-z4 m-auto" style="max-width: 380px;">
        <mat-card-title class="text-center m-b-24">{{'page.login.title' | translate}}!</mat-card-title>

        <form class="form-field-full" [formGroup]="loginForm">

            <mat-form-field appearance="outline">
                <mat-label>{{'page.login.username' | translate}}:</mat-label>
                <input matInput placeholder="{{'page.login.username' | translate}}" formControlName="username" required>
                <mat-error *ngIf="username?.invalid">
                    <span *ngIf="username?.errors?.required">
                        {{'validations.required' | translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <mat-form-field appearance="outline">
                <mat-label>{{'page.login.password' | translate}}:</mat-label>
                <input matInput placeholder="{{'page.login.password' | translate}}" type="password"
                       formControlName="password" required>
                <mat-error *ngIf="password?.invalid">
                    <span *ngIf="password?.errors?.required">
                        {{'validations.required' | translate}}
                    </span>
                </mat-error>
            </mat-form-field>

            <button class="w-full" mat-raised-button color="primary"
                    [disabled]="loginForm?.invalid"
                    (click)="login()">
                {{'page.login.login' | translate}}
            </button>

            <mat-error *ngIf="loginForm?.invalid">
                <span *ngIf="loginForm?.errors?.invalidCredentials">
                    {{'page.login.validations.invalidCredentials' | translate}}
                </span>
            </mat-error>
        </form>

    </mat-card>
</div>
